import { render, staticRenderFns } from "./RulesDetail.vue?vue&type=template&id=0584022a&scoped=true"
import script from "./RulesDetail.vue?vue&type=script&lang=js"
export * from "./RulesDetail.vue?vue&type=script&lang=js"
import style0 from "./RulesDetail.vue?vue&type=style&index=0&id=0584022a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0584022a",
  null
  
)

export default component.exports